module.exports = __webpack_public_path__ + "img/me.datang.159c86dc.png";